module.exports = __webpack_public_path__ + "media/images/emblems/Reichenbach_2farbig_transparent-73ca715637b32bf1f75abb105e289817.png";